import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SharedModule } from 'primeng/api';
import { DialogModule } from 'primeng/dialog';
import {
  ONU_DIALOG_BREAKPOINTS,
  ONU_DIALOG_STYLE,
} from '@sharedComponents/smart-olt-onu/onu-dialog-size';
import { OdbIconComponent } from './odb-icon.component';
import { OnuSplitterComponent, OnuSplitterRef } from './onu-splitter.component';

/**
 * Modal del splitter con la cabecera de SmartOLT (icono y nombre). Lo abren el detalle de la ONU y la
 * lista de ONUs de una PON; mide lo mismo que el modal de la ONU.
 */
@Component({
  selector: 'app-onu-splitter-dialog',
  standalone: true,
  imports: [DialogModule, SharedModule, OdbIconComponent, OnuSplitterComponent],
  templateUrl: './onu-splitter-dialog.component.html',
})
export class OnuSplitterDialogComponent {
  /** ONU desde la que se lee el splitter y su id; sin ella el modal está cerrado */
  @Input() splitter: OnuSplitterRef | null = null;
  @Input() name = '';
  @Output() openOnu = new EventEmitter<string>();
  @Output() changed = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();

  public readonly dialogStyle = ONU_DIALOG_STYLE;
  public readonly dialogBreakpoints = ONU_DIALOG_BREAKPOINTS;
}
